/**
 * Paliers de lecture d'un score PAMI, de 0 à 10 : le libellé du niveau et sa
 * couleur.
 *
 * Ces règles vivent dans le package SANS DÉPENDANCE parce que deux
 * consommateurs très différents s'en servent : les cartes du portail client
 * (`ScoreBar`) et le rapport PDF construit côté Convex. Les dupliquer ferait
 * diverger l'écran et le document, qui doivent dire la même chose du même
 * score.
 */

/** Rouge sous la moyenne, ambre dans la moyenne, vert au-dessus. */
export const COULEURS_NIVEAU = {
  bas: "#ef4444",
  moyen: "#f59e0b",
  haut: "#22c55e",
} as const;

/**
 * Les mêmes paliers assombris pour le TEXTE du niveau : rouge, ambre et vert
 * vifs tombent à 2-3:1 sur blanc. La teinte vive garde les aplats (barre,
 * pastille, histogramme).
 */
export const COULEURS_NIVEAU_TEXTE = {
  bas: "#B91C1C",
  moyen: "#B45309",
  haut: "#15803D",
} as const;

/** Part non atteinte d'une barre de score, dans le rapport. */
export const COULEUR_BARRE_VIDE = "#D9DEE5";

export function couleurNiveau(score: number): string {
  if (score <= 3) return COULEURS_NIVEAU.bas;
  if (score <= 6) return COULEURS_NIVEAU.moyen;
  return COULEURS_NIVEAU.haut;
}

export function couleurTexteNiveau(score: number): string {
  if (score <= 3) return COULEURS_NIVEAU_TEXTE.bas;
  if (score <= 6) return COULEURS_NIVEAU_TEXTE.moyen;
  return COULEURS_NIVEAU_TEXTE.haut;
}

export function niveauScore(score: number): string {
  if (score <= 1) return "Très bas";
  if (score <= 3) return "Bas";
  if (score <= 6) return "Dans la moyenne";
  if (score === 7) return "Au-dessus de la moyenne";
  if (score <= 8) return "Élevé";
  return "Très élevé";
}
